module.exports = __webpack_public_path__ + "img/event-gelb-neu.3416a7b7.svg";